import { expandLegacyModules } from './serverModules';

export const ALL_MODULES = [
    'dashboard', 'employees', 'employee-onboarding', 'resignations', 'inbox',
    'recruitment-categories', 'recruitment-vacancies', 'recruitment-candidates', 'recruitment-interviews', 'careers-settings',
    'document-requests', 'document-approvals', 'organisation-documents', 'employee-documents',
    'attendance-overview', 'attendance', 'attendance-reports', 'client-locations', 'location-tracking',
    'leave-applications', 'leave-apply', 'leave-my-requests', 'leave-approval',
    'permission-apply', 'permission-approve', 'permission-marked',
    'payroll-register', 'run-payroll', 'payslips', 'advances', 'overtime', 'payroll-incentives', 'increments', 'increments-growth',
    'expenses-daily', 'expenses-shoot', 'expenses-other',
    'departments', 'designations', 'roles-access', 'entities',
    'salary-structures', 'salary-unlock', 'statutory-deductions',
    'policy-setup', 'leave-types', 'working-calendar', 'assign-shifts',
    'settings',
];

export const ROLE = { MASTER_ADMIN: 1, ADMIN: 2, EMPLOYEE: 3 };

export const DEFAULT_ROLE_MODULES = {
    [ROLE.MASTER_ADMIN]: ALL_MODULES,

    [ROLE.ADMIN]: ALL_MODULES,

    [ROLE.EMPLOYEE]: [
        'inbox',
        // Employees raise their own resignation here — ResignationsPage already
        // renders a self-service view for non-approvers; it was only ever hidden
        // because this key was missing.
        'resignations',
        'leave-apply',
        'leave-my-requests',
        'permission-apply',
        'advances',
        'overtime',
        'increments',
        'increments-growth',
        'payslips',
        'organisation-documents',
    ],
};

export const isMasterAdminRole = (roleId) => Number(roleId) === ROLE.MASTER_ADMIN;

export const canAssignRole = (currentUserTypeId, roleId) => {
    const me = Number(currentUserTypeId);
    const target = Number(roleId);
    if (target === ROLE.MASTER_ADMIN) return me === ROLE.MASTER_ADMIN;
    if (target === ROLE.ADMIN) return me === ROLE.MASTER_ADMIN || me === ROLE.ADMIN;
    return true;
};

export const resolveModules = (user, serverModules) => {
    if (user?.isMasterAdmin === true) return DEFAULT_ROLE_MODULES[ROLE.MASTER_ADMIN];
    const roleId = user?.userTypeId;
    if (roleId != null && DEFAULT_ROLE_MODULES[roleId]) {
        // The built-in roles keep their fixed list, plus any Permission screen an admin has switched on for the role
        // under Roles & Access (Approve / Marked are off for Employees until then).
        const granted = Array.isArray(serverModules) ? serverModules.filter((k) => k.startsWith('permission-')) : [];
        return granted.length ? [...new Set([...DEFAULT_ROLE_MODULES[roleId], ...granted])] : DEFAULT_ROLE_MODULES[roleId];
    }
    return Array.isArray(serverModules) ? expandLegacyModules(serverModules) : [];
};
